export default __webpack_public_path__ + "static/media/saver-prohibited.5d2c6b1b.png";